// extracted by mini-css-extract-plugin
module.exports =  {"thumbnail":"gewvDDAeyFQ85dJISbd7"};